/*
 * Project: xpenser-client
 * FilePath: /src/app/components/auth-callback/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 5:26:58 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */


import React from 'react'
import { Redirect } from 'react-router-dom'

export const AuthCallbackComponent: React.FC = () => {
  // TODO - get cached page from localStorage and redirect to that
  return (<Redirect to="/dashboard" />)
}

export default AuthCallbackComponent
